export default "__VITE_ASSET__4jP_E9gG__"